import styled from "styled-components";

import Colors from '../../themes/Colors';
export const ModalSelectedCardContentHolder = styled.div`
  padding: 16px;
   .ant-alert {
    margin-top: 5px;
  }

  .ant-alert-warning {
    background-color: ${Colors.tintWarning};
    border: 1px solid #ffe58f;
    color: ${Colors.coal};
    font-size: 14px;
  }
`;
